module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Ga-Hc-Ic-Ja.ffe683da.png";